import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components/macro';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import CloseIcon from '../svg/close';
import { useTranslate } from '../../contexts/languageContext';
import { snap } from '../../resources/constantes.json';
import LogoEleccion from '../../assets/img/logoEleccion.png';

const DrawerModal = ({
  className,
  children,
  isOpen,
  setIsOpen,
  icon = 'Hamburguesa',
}) => {
  const [render, setRender] = useState(false);
  const t = useTranslate();
  useEffect(() => {
    if (isOpen) setRender(true);
  }, [isOpen]);
  return (
    <Container className={className}>
      <SButton onClick={() => setIsOpen(true)}>
        <span className="visually-hidden">
          {t('AbrirMenuNavegacionPrincipal')}
        </span>
        {icon}
      </SButton>
      <StyledDialogOverlay
        onDismiss={() => setIsOpen(false)}
        isOpen={render}
        doShow={isOpen}
        onAnimationEnd={() => {
          if (!isOpen) setRender(false);
        }}
      >
        <StyledDialogContent doShow={isOpen}>
          <div>
          <CloseButton onClick={() => setIsOpen(false)}>
            <span className="visually-hidden">
              {t('CerrarMenuNavegacionPrincipal')}
            </span>
            <CloseIcon
              width={30}
              height={30}
              fill="#1C4183"
              css={`
                vertical-align: top;
              `}
            />
          </CloseButton>
          {children}
          </div>
          <img src={LogoEleccion} alt={'Logo elección'} />
        </StyledDialogContent>
      </StyledDialogOverlay>
      {snap && <div css="display:none;">{children}</div>}
    </Container>
  );
};
const fadein = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeout = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const slidein = keyframes`
  0% {
   transform: translate3d(-200px, 0, 0) 
  }
  100% {
   transform: translate3d(0, 0, 0) 
  }
`;

const slideout = keyframes`
  0% {
   transform: translate3d(0, 0, 0) 
  }
  100% {
   transform: translate3d(-200px, 0, 0) 
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const StyledDialogOverlay = styled(({ doShow, ...rest }) => (
  <DialogOverlay {...rest} />
))`
  && {
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 2000;
    animation: ${({ doShow }) => (doShow ? fadein : fadeout)} 0.2s;
  }
`;

const StyledDialogContent = styled(({ doShow, ...rest }) => (
  <DialogContent {...rest} />
))`
  && {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 300px;
    background-color: #06CFD9;
    min-height: 400px;
    animation: ${({ doShow }) => (doShow ? slidein : slideout)} 0.2s;
    & .focus-visible {
      outline: 2px solid white;
      outline-offset: -2px;
    }
    img {
      width: 200px;
      margin: 0 auto;
    }
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  margin: 5px;
  padding: 10px;
  border-radius: 50%;
  &:hover {
    background: rgba(255, 2555, 255, 0.06);
  }
`;

const SButton = styled.button`
  width: 100%;
  height: 100%;
  line-height: 1em;
  background-color: transparent;
  border: none;
  transition: background-color 0.3s ease 0s;
  & .focus-visible {
    outline: 2px solid white;
    outline-offset: -2px;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
`;

export default DrawerModal;
